<template>
	<div>
		<el-form :model="task" label-width="140px">
			<el-form-item label="Create Task">
				<el-select class="w-100" v-model="task.create" placeholder="Create a task">
					<el-option :value="true" label="Yes"></el-option>
					<el-option :value="false" label="No"></el-option>
				</el-select>
			</el-form-item>

			<div v-if="task.create">
				<el-form-item label="Task">
					<el-input placeholder="Task name" v-model="task.name"></el-input>
				</el-form-item>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="Task Date">
							<el-date-picker
								class="w-100"
								v-model="task.remindMe"
								type="date"
								placeholder="Task Date"
								format="dd/MM/yyyy"
							></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="Task Time">
							<el-time-picker
								class="w-100"
								placeholder="Task Time"
								v-model="task.time"
                                value-format="HH:mm:ss"
							></el-time-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
		</el-form>
	</div>
</template>

<script>
	import { mapState, mapGetters } from "vuex"

	export default {
		name: "EmailTask",
		props: {
            userId: {
                type: [Number, String],
                required: false,
                default: ""
            }
        },
		data() {
			return {
                task: {
                    create: false,
                    userId: this.userId,
                    name: "",
                    remindMe: new Date(),
                    time: "17:00:00"
                }
            }
		},
		computed: {
			...mapGetters({
				emailBuilder: "builderEmail/getEmail",
			}),
		},
		mounted() {
   
        },
		methods: {},
        watch: {
            task: {
                handler(task) {
                    this.$emit('input', task);
                },
                deep: true,
                immediate: true
            }
        }
	}
</script>

<style lang="scss" scoped>
</style>